import { FC, useCallback, useState } from "react"
import { discussionRecipientsNotifyApi } from "src/domain/api/discussion/discussionRecipientsNotifyApi"
import { Discussion } from "src/domain/entities/discussion"
import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	discussion: Discussion
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const DiscussionNotifyDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	discussion,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleDiscussionNotify = useCallback(async () => {
		try {
			setIsLoading(true)
			await discussionRecipientsNotifyApi({ id: discussion.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [discussion, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Notify Discussion: ${discussion.text}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleDiscussionNotify}
			isLoading={isLoading}
			errorMessage={errorMessage}
			confirmationText="Notify"
		/>
	)
}
